// Modül 3 - Ünite 3, 4, 5, 6 İçerikleri
// Aday Nasıl Davranmalı? - İletişim, Grup Dinamiği, Hatalar, Final

const cabinCrewContentsM3U3to6 = {
  // ==================== ÜNİTE 3: İLETİŞİM ====================
  'CM-M3-U3-L1': {
    lesson_id: 'CM-M3-U3-L1',
    title: 'Sözsüz İletişim',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Beden Dili ve Non-verbal İletişim',
      paragraphs: [
        'İletişimin %55\'i beden dili, %38\'i ses tonu, sadece %7\'si kelimelerdir.',
        'Göz teması: Konuşurken ve dinlerken göz teması kurun. Kaçınmak güvensizlik gösterir.',
        'Gülümseme: Doğal, samimi gülümseme. Sahte gülümseme hemen anlaşılır.',
        'Duruş: Dik ama rahat. Kolları kavuşturmayın, açık duruş sergileyin.',
        'El hareketleri: Doğal, aşırı olmayan. Eller masanın üstünde, görünür olsun.',
        'Yüz ifadesi: İlgi ve dikkat gösteren, tepkisel. Sıkılmış veya kayıtsız değil.'
      ],
      keyPoints: [
        'Beden dili kelimelerden güçlü',
        'Göz teması ve gülümseme kritik',
        'Açık, rahat duruş',
        'Doğal el hareketleri'
      ]
    }
  },

  'CM-M3-U3-L2': {
    lesson_id: 'CM-M3-U3-L2',
    title: 'Etkili Konuşma Teknikleri',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Mülakatta Nasıl Konuşmalı?',
      paragraphs: [
        'Tempo: Ne çok hızlı ne çok yavaş. Düşünerek, net konuşun.',
        'Ses tonu: Monoton değil, vurgulu. Önemli noktaları tonlama ile belirtin.',
        'Duraklama: Düşünmek için duraklamak normaldir. "Eee" demek yerine sessizce düşünün.',
        'Cümle yapısı: Kısa, anlaşılır cümleler. Karmaşık, uzun cümlelerden kaçının.',
        'Filler words: "Yani, şey, hani" gibi dolgu kelimeleri minimize edin.',
        'Özgüven: Cümlelerinizi soru gibi değil, ifade gibi bitirin. Sesiniz emin olsun.'
      ],
      keyPoints: [
        'Düşünceli ve net tempo',
        'Vurgulu, monoton olmayan ses',
        'Kısa ve anlaşılır cümleler',
        'Dolgu kelimelerden kaçının'
      ]
    }
  },

  'CM-M3-U3-L3': {
    lesson_id: 'CM-M3-U3-L3',
    title: 'Senaryo: Zor Soru Anı',
    type: 'scenario',
    duration: 8,
    xp: 40,
    scenario: {
      context: 'Mülakatta beklemediğiniz bir soru geldi ve cevabı bilmiyorsunuz:',
      question: '"Havayolumuzun son açıkladığı yeni rotası neresidir?" Cevabı bilmiyorsunuz. Ne yaparsınız?',
      options: [
        { id: 'A', text: 'Bilmiyorum, araştırmadım.', isCorrect: false },
        { id: 'B', text: 'Sanırım Dubai olabilir? Emin değilim.', isCorrect: false },
        { id: 'C', text: 'Bu detayı bilmiyorum ama havayolunuzun büyüme stratejisini takip ediyorum ve öğrenmek için heyecanlıyım.', isCorrect: true },
        { id: 'D', text: 'Sessiz kalır ve başka soruya geçmelerini beklerim.', isCorrect: false }
      ],
      feedback: {
        correct: 'Harika! Dürüstlük + pozitif yönlendirme + ilgi gösterme. Bu profesyonel bir cevap.',
        wrong: 'Bu cevap ya savunmacı ya da güvensiz. Bilmediğinizi kabul edip ilgi göstermek en iyi strateji.'
      },
      explanation: 'Mülakatçılar her şeyi bilmenizi beklemez. Önemli olan: dürüstlük, öğrenme isteği ve pozitif tutum.'
    }
  },

  'CM-M3-U3-L4': {
    lesson_id: 'CM-M3-U3-L4',
    title: '🎮 İletişim Eşleştirme',
    type: 'matching',
    duration: 4,
    xp: 35,
    matching: {
      pairs: [
        { left: 'Göz teması', right: 'Güven ve ilgi gösterir' },
        { left: 'Kolları kavuşturmak', right: 'Savunmacı duruş' },
        { left: 'Doğal gülümseme', right: 'Samimiyet gösterir' },
        { left: 'Monoton ses', right: 'İlgisizlik izlenimi' },
        { left: 'Filler words', right: 'Eee, yani, şey' },
        { left: 'Aktif dinleme', right: 'Anlama ve tepki verme' }
      ]
    }
  },

  // ==================== ÜNİTE 4: GRUP DİNAMİĞİ ====================
  'CM-M3-U4-L1': {
    lesson_id: 'CM-M3-U4-L1',
    title: 'Grup Mülakatında Roller',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Grup İçindeki Doğal Roller',
      paragraphs: [
        'Grup mülakatlarında insanlar doğal olarak belirli rollere kayar. Bunları tanıyın.',
        'Lider: İnisiyatif alır, organize eder. Tehlike: Baskın olmak, başkalarını susturmak.',
        'Destekçi: Fikirleri geliştirir, başkalarını destekler. Tehlike: Kendi fikri olmamak.',
        'Yaratıcı: Yeni fikirler sunar. Tehlike: Pratik olmayan öneriler, konudan sapmak.',
        'Analizci: Detayları değerlendirir, mantıklı düşünür. Tehlike: Çok eleştirel, yavaş.',
        'En iyi strateji: Esnek olun. Duruma göre farklı roller üstlenebileceğinizi gösterin.'
      ],
      keyPoints: [
        'Her rolün avantajları ve riskleri var',
        'Tek bir role saplanmayın',
        'Duruma göre esnek olun',
        'Takım başarısı bireysel başarıdan önemli'
      ]
    }
  },

  'CM-M3-U4-L2': {
    lesson_id: 'CM-M3-U4-L2',
    title: 'Rekabet vs İşbirliği',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Grup Mülakatında Doğru Denge',
      paragraphs: [
        'Grup mülakatı paradoks: Diğer adaylarla rekabet ediyorsunuz AMA işbirliği de değerlendiriliyor.',
        'Yanlış yaklaşım: Diğerlerini küçümsemek, sözlerini kesmek, show yapmak.',
        'Doğru yaklaşım: Kendi fikirlerinizi sunun VE başkalarının fikirlerini destekleyin/geliştirin.',
        'Sihirli formül: "Ben ve biz" - Bireysel katkınızı gösterin ama takım başarısına da katkı sağlayın.',
        'Mülakatçılar şunu izler: "Bu kişi uçakta ekibimle iyi çalışır mı?"'
      ],
      keyPoints: [
        'Rekabet değil, işbirlikçi rekabet',
        'Kendi fikrinizi sunun + başkalarını destekleyin',
        'Baskın veya görünmez olmayın',
        'Takım oyuncusu izlenimi bırakın'
      ]
    }
  },

  'CM-M3-U4-L3': {
    lesson_id: 'CM-M3-U4-L3',
    title: 'Senaryo: Baskın Aday',
    type: 'scenario',
    duration: 8,
    xp: 40,
    scenario: {
      context: 'Grup mülakatında bir aday sürekli konuşuyor, başkalarına fırsat vermiyor:',
      question: 'Bu durumda ne yaparsınız?',
      options: [
        { id: 'A', text: 'Sessiz kalır, onun bitmesini beklerim.', isCorrect: false },
        { id: 'B', text: 'Sözünü keserim ve kendi fikrimi söylerim.', isCorrect: false },
        { id: 'C', text: 'Kibar bir şekilde konuşmaya dahil olurum: "Güzel bir nokta, buna eklemek istiyorum..." veya "Bu konuda başka fikirleri de duymak ister misiniz?"', isCorrect: true },
        { id: 'D', text: 'Mülakatçıya şikayet ederim.', isCorrect: false }
      ],
      feedback: {
        correct: 'Mükemmel! Diplomatik, proaktif ve kapsayıcı. Bu liderlik ve takım becerisi gösterir.',
        wrong: 'Bu yaklaşım ya pasif ya da agresif. Diplomatik müdahale en iyi strateji.'
      },
      explanation: 'Zor kişilerle başa çıkma becerisi kabin memurluğunda kritik. Yolcular, ekip arkadaşları... Diplomatik çözümler bulmak şart.'
    }
  },

  'CM-M3-U4-L4': {
    lesson_id: 'CM-M3-U4-L4',
    title: '⚡ Rol Yarışı',
    type: 'timerace',
    duration: 4,
    xp: 45,
    timerace: {
      timePerQuestion: 8,
      questions: [
        { q: 'Grup mülakatında en önemli beceri?', options: ['Solo performans', 'İşbirliği', 'Sessizlik', 'Eleştiri'], correct: 1 },
        { q: 'Baskın olmak ne tür bir risk?', options: ['Fark edilmemek', 'Takım oyuncusu olmamak', 'Çok sessiz', 'Çok yaratıcı'], correct: 1 },
        { q: '"Destekçi" rolün tehlikesi?', options: ['Çok lider', 'Kendi fikri olmamak', 'Çok hızlı', 'Çok yaratıcı'], correct: 1 },
        { q: 'Grup mülakatında mülakatçılar neyi izler?', options: ['En çok konuşanı', 'En az hata yapanı', 'Takım dinamiğini', 'En güzel giyineni'], correct: 2 },
        { q: 'Diğer adayın sözünü kesmek nasıl algılanır?', options: ['Liderlik', 'Saygısızlık', 'Cesaret', 'Yaratıcılık'], correct: 1 }
      ]
    }
  },

  // ==================== ÜNİTE 5: SIK YAPILAN HATALAR ====================
  'CM-M3-U5-L1': {
    lesson_id: 'CM-M3-U5-L1',
    title: 'Sık Yapılan Hatalar',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Grup Mülakatında Yapılmaması Gerekenler',
      paragraphs: [
        'Hatalardan kaçınmak, doğru şeyleri yapmak kadar önemlidir.',
        'Hata 1: Çok sessiz kalmak. Hiç görünmezseniz, değerlendirilemezsiniz.',
        'Hata 2: Çok baskın olmak. Sürekli konuşmak, başkalarını susturmak.',
        'Hata 3: Diğer adayları eleştirmek. "O yanlış söyledi" demek yerine kendi fikrinizi sunun.',
        'Hata 4: Mülakatçıyla tartışmak. Onlar her zaman haklıdır (en azından orada).',
        'Hata 5: Negatif beden dili. Somurtmak, göz devirmek, iç çekmek.'
      ],
      keyPoints: [
        'Ne çok sessiz ne çok baskın',
        'Diğer adayları eleştirmeyin',
        'Mülakatçıyla tartışmayın',
        'Beden dilinize dikkat edin'
      ]
    }
  },

  'CM-M3-U5-L2': {
    lesson_id: 'CM-M3-U5-L2',
    title: 'Senaryo: Fikir Çatışması',
    type: 'scenario',
    duration: 8,
    xp: 40,
    scenario: {
      context: 'Grup görevinde başka bir aday sizin fikrinizle çelişen bir öneri sundu:',
      question: 'Nasıl tepki verirsiniz?',
      options: [
        { id: 'A', text: '"Bu yanlış bir yaklaşım" diyerek karşı çıkarım.', isCorrect: false },
        { id: 'B', text: 'Sessiz kalır, fikrimi geri çekerim.', isCorrect: false },
        { id: 'C', text: '"İlginç bir bakış açısı. Benim önerimle birleştirirsek, belki şöyle bir çözüm bulabiliriz..." diyerek uzlaşma ararım.', isCorrect: true },
        { id: 'D', text: 'Mülakatçılara hangisinin doğru olduğunu sorarım.', isCorrect: false }
      ],
      feedback: {
        correct: 'Harika! Diplomatik, yapıcı ve işbirlikçi. Bu tam da aranan yaklaşım.',
        wrong: 'Bu tepki ya çatışmacı ya da pasif. Uzlaşma ve birleştirme en iyi strateji.'
      },
      explanation: 'Farklı fikirler normaldir. Önemli olan çatışmayı yönetme ve ortak çözüm bulma becerisi. Bu kabin ekibinde kritik.'
    }
  },

  'CM-M3-U5-L3': {
    lesson_id: 'CM-M3-U5-L3',
    title: '🎮 Hata Bul: Doğru/Yanlış',
    type: 'truefalse',
    duration: 4,
    xp: 35,
    truefalse: {
      statements: [
        { statement: 'Grup mülakatında sessiz kalmak güvenli bir stratejidir.', isTrue: false, explanation: 'Yanlış! Görünmezseniz değerlendirilemezsiniz.' },
        { statement: 'Diğer adayların fikirlerini geliştirmek iyi izlenim bırakır.', isTrue: true, explanation: 'Doğru! Bu takım oyuncusu olduğunuzu gösterir.' },
        { statement: 'Mülakatçıyla tartışmak cesaret gösterir.', isTrue: false, explanation: 'Kesinlikle yanlış! Saygısızlık olarak algılanır.' },
        { statement: 'Beden dili değerlendirmede önemli bir faktördür.', isTrue: true, explanation: 'Doğru! Sözsüz iletişim kritik öneme sahip.' },
        { statement: 'En çok konuşan aday en iyi puanı alır.', isTrue: false, explanation: 'Yanlış! Kalite miktardan önemli. Baskın olmak riskli.' }
      ]
    }
  },

  // ==================== ÜNİTE 6: FİNAL ====================
  'CM-M3-U6-L1': {
    lesson_id: 'CM-M3-U6-L1',
    title: '🎓 Modül 3 Final Sınavı',
    type: 'exam',
    duration: 10,
    xp: 80,
    exam: {
      questions: [
        { q: 'İletişimin yüzde kaçı beden dilidir?', options: ['%10', '%30', '%55', '%80'], correct: 2 },
        { q: 'Grup mülakatında ideal strateji?', options: ['Baskın ol', 'Sessiz kal', 'Dengeli katılım', 'Sadece dinle'], correct: 2 },
        { q: 'Diğer adayın sözünü kesmek nasıl algılanır?', options: ['Liderlik', 'Saygısızlık', 'Cesaret', 'İlgi'], correct: 1 },
        { q: '"Filler words" ne demektir?', options: ['Önemli kelimeler', 'Dolgu kelimeleri (eee, yani)', 'Teknik terimler', 'Yabancı kelimeler'], correct: 1 },
        { q: 'Kolları kavuşturmak ne ifade eder?', options: ['Rahatlık', 'Savunmacılık', 'İlgi', 'Liderlik'], correct: 1 },
        { q: 'Grup görevinde fikir çatışmasında ne yapmalı?', options: ['Tartışmak', 'Sessiz kalmak', 'Uzlaşma aramak', 'Şikayet etmek'], correct: 2 },
        { q: 'En sık yapılan grup mülakatı hatası?', options: ['Çok gülümsemek', 'Çok sessiz veya çok baskın olmak', 'Çok soru sormak', 'Çok erken gelmek'], correct: 1 },
        { q: 'Mülakatçıyla anlaşmazlık durumunda?', options: ['Tartışın', 'Haklı olduğunuzu kanıtlayın', 'Diplomatik olun', 'Sessiz kalın'], correct: 2 },
        { q: 'Grup dinamiğinde "destekçi" rolün riski?', options: ['Çok baskın', 'Kendi fikri olmamak', 'Çok yaratıcı', 'Çok hızlı'], correct: 1 },
        { q: 'Aktif dinleme ne içerir?', options: ['Sadece sessizlik', 'Anlama ve tepki verme', 'Not alma', 'Sorular sormak'], correct: 1 }
      ]
    }
  }
};

export default cabinCrewContentsM3U3to6;
